<template>
  <div class="page-wrapper">
    <menu-dispatcher></menu-dispatcher>
    <alert-window ref="alertWindow"></alert-window>

    <div class="wrapper">
      <header-dispatcher></header-dispatcher>
      <div class="screen-container">
        <div class="center-content">
          <div class="content-box">
            <div class="content-head">
              <div class="title">
                <router-link to="/directories/leeway" style="color:black">
                  <a class="back" title="Назад"><img src="../image/back.png"></a>Редактировать
                </router-link>
              </div>
              <div class="cabinet-body"></div>
            </div>
            <div class="content-body directorys-page">
              <div class="cabinet-info">
                <div class="directory-box">
                  <div class="main-content">
                    <div class="form">
                      <div class="fieldset">
                        <label class="fieldset-title">Наименование</label>
                        <fieldset><input type="text" v-model="leeway.name"
                                         readonly></fieldset>
                      </div>
                      <div class="fieldset">
                        <label class="fieldset-title">Запас времени, час.</label>
                        <fieldset><input type="text" v-mask="'##:##'" placeholder="HH:mm" v-model="time"></fieldset>
                      </div>
                      <div class="buttons">
                        <button type="button" class="save-button" @click="save">Сохранить
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
    import MenuDispatcher from '@/components/MenuDispatcher.vue'
    import HeaderDispatcher from '@/components/HeaderDispatcher.vue'
    import api from '@/api'
    import utils from '@/utils'
    import {mask} from 'vue-the-mask'
    import AlertWindow from '@/components/AlertWindow.vue'

    export default {
  name: 'Leeway',
  components: {
    MenuDispatcher,
    HeaderDispatcher,
    AlertWindow
  },
  directives: { mask },

  data () {
    return {
      leeway: {
        name: null,
        time: null
      },
      tempTime: null
    }
  },

  mounted () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.add('cabinet-page')

    let id = this.$route.params.id

    api
      .getLeewayById(id)
      .then(leeway => {
        if (leeway) {
          this.leeway = leeway
        }
      })
  },
  computed: {
    time: {
      get () {
        return this.tempTime = utils.getFormattedTimeStringFromLongWithoutTimezone((new Date()).setHours(0, 0, 0, 0) + (this.leeway.time))
      },

      set (value) {
        this.tempTime = value
        if (value.length === 5) { this.leeway.time = utils.getLongFromFormattedTimeString(value) }
      }
    }
  },

  destroyed () {
    let body = document.getElementsByTagName('body')[0]
    body.classList.remove('cabinet-page')
  },

  methods: {
    save () {
      if (this.tempTime.length !== 5) {
        this.$refs.alertWindow.show('Ошибка', 'Введен неверный формат времени!')
        return false
      }

      if (this.$store.getters.waitingApiRequestsCount != 0) { return }

      api
        .updateLeewayTime(this.leeway.id, this.leeway)
        .then(() => {
          this.$refs.alertWindow.show('Уведомление', 'Сохранено', true, () => this.$router.push('/directories/leeway'))
        })
        .catch(err => alert(err))
    }
  }
}
</script>
